import * as React from "react";
import { styled } from "sharedUI/styles";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";

import { GlideFC } from "lib/glide-fc";
import { SliderWrapper } from "../property-configurator/enum-slider-style";

const ValueSliderWrapper = styled.div`
    width: 100%;
    margin: 4px 0px;
`;

interface Props {
    min: number;
    max: number;
    step: number;
    value: number;
    clampedMin?: number;
    clampedMax?: number;
    margin?: number;
    onSelectionChanged: (val: number) => void;
}

export const ValueSlider: GlideFC<Props> = p => {
    const { value, min, max, step, onSelectionChanged, margin, clampedMin, clampedMax } = p;

    const clampIfNecessary = React.useCallback(
        (val: number) => {
            let clamped = val;
            if (clampedMin !== undefined) {
                clamped = Math.max(clamped, clampedMin);
            }
            if (clampedMax !== undefined) {
                clamped = Math.min(clamped, clampedMax);
            }
            onSelectionChanged(clamped);
        },
        [clampedMax, clampedMin, onSelectionChanged]
    );

    const horizMargin = margin ?? 7;

    return (
        <ValueSliderWrapper>
            <SliderWrapper horizMargin={horizMargin}>
                <Slider min={min} max={max} step={step} value={value} onChange={clampIfNecessary} />
            </SliderWrapper>
        </ValueSliderWrapper>
    );
};
